module.exports = __webpack_public_path__ + "img/ALIPAY2x.png?bba321d1d3aad4acdb8d18f622549476";